import React from "react";
import { Flex, Center } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import {Error, TopBand} from "../src/components/common";

import CartTotal from "../src/components/cart/cartTotal";
import CartItemList from "../src/components/cart/cartItemList";
import EmptyCart from "../src/components/drawerCart/emptyCart";
import MobileCartItemList from "../src/components/cart/mobileCartItemList";

import { wrapper } from "../src/redux/store";
import { fetchProductCategories } from "../src/redux/actions";

export default function Cart({ errorMessage }) {
  if (errorMessage) {
    return <Error errorMessage={errorMessage} />;
  }
  const { cart } = useSelector((state) => state);

  return (
    <>
      <TopBand title="My Cart" />
      <Center my="50px">
        {cart.length > 0 ? (
          <Flex
            width={{ base: "90%", "2xl": "1350px" }}
            flexDirection={{ base: "column", xl: "row" }}
          >
            <CartItemList cart={cart} />
            <MobileCartItemList cart={cart} />
            <CartTotal cart={cart} />
          </Flex>
        ) : (
          <Flex width="40%" margin="auto" mt="5%">
            <EmptyCart px={50} />
          </Flex>
        )}
      </Center>
    </>
  );
}

export const getStaticProps = wrapper.getStaticProps((store) => async () => {
  try {
    await store.dispatch(fetchProductCategories());
  } catch (err) {
    return {
      props: {
        errorMessage: err.message,
      },
    };
  }
});
